import { useState } from "react";
import { Stack, Box, Typography, StackProps } from "@mui/material";
import Logo from "src/images/icon-square-small.png";

interface Props extends StackProps {
    label: string;
    src: string;
    external: boolean;
}

export const NavbarLogo = ({ label = "", src = "", external, sx }: Props) => {
    const [logoValid, setLogoValid] = useState(true);

    return (
        <Stack
            spacing={1}
            direction="row"
            alignItems="center"
            sx={{
                maxWidth: { md: "25%" },
                overflow: "hidden",
                ...(sx && sx),
            }}
        >
            <Box
                component="img"
                src={logoValid ? src : Logo}
                alt={`${label} logo`}
                sx={{
                    height: { xs: 42, md: external ? 64 : 42 },
                    width: { xs: 42, md: external ? 100 : 42 },
                    color: "primary.contrastText",
                    objectFit: "contain",
                }}
                onError={() => setLogoValid(false)}
            />

            <Box>
                {label && (
                    <Typography
                        variant="subtitle2"
                        component="span"
                        textTransform="uppercase"
                    >
                        Connect Rider
                    </Typography>
                )}

                <Typography
                    noWrap
                    sx={{
                        lineHeight: 1,
                        fontSize: { md: 20 },
                        fontWeight: "medium",
                        letterSpacing: ".1rem",
                        color: "primary.contrastText",
                        textTransform: !label ? "uppercase" : "none",
                    }}
                >
                    {label ? label : "Connect Rider"}
                </Typography>
            </Box>
        </Stack>
    );
};

export default NavbarLogo;
